export default {
  components: {
    signUpHeader: {
      title: 'dt.auth.components.signUpHeader.title',
    },
  },
  forgotPassword: {
    emailInput: 'dt.auth.forgotPassword.emailInput',
    requestPasswordLinkButton: 'dt.auth.forgotPassword.requestPasswordLinkButton',
    passwordInput: 'dt.auth.forgotPassword.passwordInput',
    resetPasswordButton: 'dt.auth.forgotPassword.resetPasswordButton',
  },
  kycStartForm: {
    phoneInput: 'dt.auth.kycStartForm.phoneInput',
    monthField: 'dt.auth.kycStartForm.monthField',
    dateField: 'dt.auth.kycStartForm.dateField',
    yearField: 'dt.auth.kycStartForm.yearField',
    consentCheckbox: 'dt.auth.kycStartForm.consentCheckbox',
    continueButton: 'dt.auth.kycStartForm.continueButton',
    enterManuallyLink: 'dt.auth.kycStartForm.enterManuallyLink',
  },
};
